<template>
  <div style="position:relative;">
    <div class="detailsTitle">
      <h4>打印预览</h4>
    </div>
    <el-button style="position:absolute;top:0;left:100px;" type="primary" @click="fanhui">返回</el-button>
    <div class="pageMain">

      <div id="printMe" ref="print1">

        <!-- 打印 -->
        <div v-for="(item, index) in list" :key="index" class="div">
          <div class="divInner" style="page-break-after:always;">
            <div class="VoyageNoShipName"><span style="margin-right:30px;">{{item.VoyageNo}}</span> <span>{{item.ShipName}}</span></div>
            <div class="OrderNumber">{{item.OrderNumber}}</div>
            <div class="CargoHAF"><span>{{item.CargoHold}}舱</span><span style="margin:0 30px;">{{item.CargoArea}}排</span><span>{{item.CargoFloor}}</span></div>
            <qriously v-show="getFlag" :id="'qriously' + index" :value="item.qrCode" :size="160" />
            <img :src="item.src" alt="" v-show="!getFlag" />
          </div>

        </div>
      </div>
      <div class="btns">
        <el-button style="margin-bottom:20px" :disabled="lastDis" type="primary" @click="lastOne">上一个</el-button>
        <el-button style="margin-bottom:20px" :disabled="nextDis" type="primary" @click="nextOne">下一个</el-button>
        <el-button style="margin-bottom:20px" type="primary" @click="dayin('one')">打印</el-button>
        <el-button style="margin-bottom:20px" type="primary" @click="AllprintContext">全部打印</el-button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      lists: JSON.parse(this.$route.query.list),
      getFlag: true,
      current: 0,
      nextDis: false,
      lastDis: true
    }
  },
  created () {
    this.list.push(this.lists[0])
    if (this.lists.length == 1) {
      this.nextDis = true
      this.lastDis = true
    }
  },
  methods: {
    fanhui () {
      this.$router.go(-1)
    },
    lastOne () {
      this.nextDis = false
      this.current--

      this.list = []
      this.list.push(this.lists[this.current])
      this.list.forEach((item, index) => {
        // item.qrCode = this.utf16to8(item.qrCode)
        item.src = ''
        let canvas = document.querySelector(
          '#qriously' + index + ' ' + 'canvas'
        )
        item.src = canvas.toDataURL('image/png')
      })
      if (this.current <= 0) {
        this.lastDis = true
      }
    },
    nextOne () {
      this.lastDis = false
      this.current++
      console.log(this.current)

      this.list = []
      this.list.push(this.lists[this.current])
      this.list.forEach((item, index) => {
        // item.qrCode = this.utf16to8(item.qrCode)
        item.src = ''
        let canvas = document.querySelector(
          '#qriously' + index + ' ' + 'canvas'
        )
        item.src = canvas.toDataURL('image/png')
      })
      if (this.current >= this.lists.length - 1) {
        this.nextDis = true
      }
    },
    AllprintContext () {
      this.list = JSON.parse(JSON.stringify(this.lists))
      setTimeout(() => {
        this.printContext('one')
      }, 500)
    },
    dayin () {
      this.list = []
      this.list.push(this.lists[this.current])
      setTimeout(() => {
        this.printContext('one')
      }, 500)
    },
    printContext (name) {
      this.getFlag = false
      this.list.forEach((item, index) => {
        // item.qrCode = this.utf16to8(item.qrCode)
        item.src = ''
        let canvas = document.querySelector(
          '#qriously' + index + ' ' + 'canvas'
        )
        item.src = canvas.toDataURL('image/png')
      })
      console.log(this.list)
      if (name == 'one') {
        setTimeout(() => {
          this.$print(this.$refs.print1)
        }, 500)
      }
    },
    // 二维码支持中文
    utf16to8 (str) {
      var out, i, len, c
      out = ''
      len = str.length
      for (i = 0; i < len; i++) {
        c = str.charCodeAt(i)
        if (c >= 0x0001 && c <= 0x007f) {
          out += str.charAt(i)
        } else if (c > 0x07ff) {
          out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f))
          out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f))
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f))
        } else {
          out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f))
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f))
        }
      }
      console.log(out)
      return out
    }
  }
}
</script>

<style lang="less" scoped >
.pageMain {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
#printMe {
  height: 480px;
  overflow: hidden;
}
.div {
  width: 480px;
  height: 480px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  padding: 40px;
  .divInner {
    width: 400px;
    height: 400px;
    border: 1px solid #ccc;
    border-radius: 50%;
    box-sizing: border-box;
    padding: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .VoyageNoShipName {
      font-size: 27px;
      font-weight: 600;
      margin-bottom: 5px;
      margin-top: 15px;
    }
    .OrderNumber {
      margin-bottom: 5px;
      font-size: 18px;
    }
    .CargoHAF {
      margin-bottom: 15px;
      font-size: 26px;
    }
  }
}
.btns {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}
</style>
